// extracted by mini-css-extract-plugin
export default {"secondNav":"index_secondNav_dtsui"};